import { computed, ref, onMounted } from 'vue';
import { useUserStore } from '/@/store/modules/user';
import { getGlobalConfig } from '/@/api/sys/user';

export function useAppUserStore() {
  const userStore = useUserStore();

  const userInfo = computed(() => {
    return userStore.getUserInfo;
  });

  const user = computed(() => {
    return userStore.getUserInfo?.user;
  });

  const token = computed(() => {
    return userStore.getToken;
  });

  const globalConfig = ref();
  const handleGlobalConfig = async () => {
    const config = await getGlobalConfig();
    globalConfig.value = config;
    userStore.setGlobalConfig(config);
  };

  onMounted(async () => {
    await handleGlobalConfig();
  });

  return {
    userInfo,
    user,
    token,
    globalConfig,
  };
}
